import { create } from 'zustand';

interface LocationState {
  selectedLocationId: string | null;
}

interface LocationActions {
  setSelectedLocation: (locationId: string | null) => void;
}

type LocationStore = LocationState & LocationActions;

export const useLocationStore = create<LocationStore>((set) => ({
  selectedLocationId: null,
  setSelectedLocation: (locationId: string | null) => set({ selectedLocationId: locationId }),
}));
